
    const original = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"16.63\" height=\"17.5\" viewBox=\"0,0,16.63,17.5\"><g transform=\"translate(-231.685,-171.25)\"><g stroke=\"#855cd6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\"><path d=\"M232.435,173.25c2.282,-1.69841 5.408,-1.69841 7.69,0v0c2.282,1.69841 5.408,1.69841 7.69,0v10.4c-2.282,1.69841 -5.408,1.69841 -7.69,0v0c-2.282,-1.69841 -5.408,-1.69841 -7.69,0\" fill=\"#855cd6\" stroke-width=\"1\"/><path d=\"M232.435,188v-16\" fill=\"#4cbf56\" stroke-width=\"1.5\"/></g></g></svg><!--rotationCenter:8.314999999999998:8.75-->";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
